import { apiClient } from "./apiClient";
import { unwrapApiResponse } from "../shared/utils/apiResponse";

export type DashboardKpi = {
  revenueThisMonth: number;
  expensesThisMonth: number;
  billsThisMonth: number;
  dailyEntriesThisMonth: number;
  revenueFY: number;
  expensesFY: number;
  netProfitFY: number;
  taxCollectedFY: number;
  taxPaidFY: number;
  totalReceivables: number;
  totalPayables: number;
  receivableInvoiceCount: number;
  payableInvoiceCount: number;
  todayEntriesCount: number;
  totalActiveParties: number;
  monthlyTrend: Array<{ label: string; revenue: number; expenses: number }>;
  topDebtors: Array<{ name: string; totalAmount: number; invoiceCount: number }>;
  recentActivity: Array<{ module: string; voucherType: string; description: string; amount: number; date: string }>;
  generatedAt: string;
  financialYear: string;
};

export async function getDashboardKpis(forceRefresh = false) {
  const { data } = forceRefresh
    ? await apiClient.post("/dashboard/kpis/refresh")
    : await apiClient.get("/dashboard/kpis");
  return unwrapApiResponse<DashboardKpi>(data);
}
